import Vue from 'vue'
import axios from 'axios'
import api from "@/api/index"
//import api from "@/api/index"

const acc = {
    namespaced: true,
    state: {



    },
    mutations: {
        LOAD: (state, info) => {

        }
        , CLEAR({state}) {
        }


    },

    actions: {
        getAccList({commit, dispatch, getters}, fdata) {

            return new Promise((resolve, reject) => {
                api.acc.getAccList(fdata)
                    .then(function (resp) {

                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }

                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },
        getAccInfo({commit, dispatch, getters}, fdata) {

            return new Promise((resolve, reject) => {
                api.acc.getAccInfo(fdata)
                    .then(function (resp) {

                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },
        updateAcc({commit, dispatch, getters}, fdata) {

            return new Promise((resolve, reject) => {
                api.acc.updateAcc(fdata)
                    .then(function (resp) {
                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },

        deleteAcc({commit, dispatch, getters}, fdata) {
            return new Promise((resolve, reject) => {
                api.acc.deleteAcc(fdata)
                    .then(function (resp) {
                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },
        getAccMonth({commit, dispatch, getters}, fdata) {
            return new Promise((resolve, reject) => {
                api.acc.getAccMonth(fdata)
                    .then(function (resp) {
                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },
        getAccDay({commit, dispatch, getters}, fdata) {
            return new Promise((resolve, reject) => {
                api.acc.getAccDay(fdata)
                    .then(function (resp) {

                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },
        getAccTime({commit, dispatch, getters}, fdata) {
            return new Promise((resolve, reject) => {
                api.acc.getAccTime(fdata)
                    .then(function (resp) {

                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },
        getAccWeek({commit, dispatch, getters}, fdata) {
            return new Promise((resolve, reject) => {
                api.acc.getAccWeek(fdata)
                    .then(function (resp) {

                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);

                    });
            })
        },
        getAccEng({commit, dispatch, getters}, fdata) {
            return new Promise((resolve, reject) => {
                api.acc.getAccEng(fdata)
                    .then(function (resp) {

                        if (resp.result == 'succeed') {
                            resolve(resp);
                        } else {
                            reject(error);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            })
        },

    }
    , getters: {
        // isLogin : state => state._id == "" ? false : true
    }
}

export default acc
